import $ from "jquery";
import { AzureFileUploadHelper } from "./azure-file-upload-helper";

let myInstance = null;

$(document).ready(function() {
    let formInstance = $('#owner-verification-form');
    if (formInstance.length > 0) {
        myInstance = new ResaleOwnerVerificationForm(formInstance);
    }
});

class ResaleOwnerVerificationForm
{
    /**
     * Constructor
     * 
     * @param {jquery object} f
     */
    constructor(frm)
    {
        this.form = frm;
        this.fileUploader = null;
        this.filesUploaded = [];
        
        //This value will be set when address has been validated.
        this.lotCostCenterId = '';

        this.attachFileUploadValidatorEvents();
    }

    startFileUpload()
    {
        let fileInputFieldIds = [];
        this.form.find('.upload-input').each( function(idx) {
            let jqf = $(this);
            fileInputFieldIds.push(jqf.attr('id'));
        });

        if (fileInputFieldIds.length > 0) {
            // Initialize the file uploader
            myInstance.fileUploader = AzureFileUploadHelper();
            myInstance.filesUploaded = [];

            this.fileUploader.initialize(
                {
                    fileInputFieldIds: fileInputFieldIds,
                    isLoggedInMSHUserRequired: false,
                    lotCostCenterId: this.lotCostCenterId,
                    storageContext: 'resale-owner-verification'
                }
            );
            
            this.fileUploader.uploadFiles(this.onUploadComplete, this.onUploadProgress);
        } else {
            //There were no files specified, so show error.
            this.onUploadComplete(false, {errorMsg: 'No file file upload fields found.'});
        }
    }

    onUploadProgress(progress) {
        if (progress.succeeded) {
            myInstance.filesUploaded.push(progress.file);
        }
        else {
            console.log(progress.elementID + " " + progress.file.name + " " + progress.percent + "%");
        }
    }

    reEnableSubmit() {
        // The ajax call completed. Re-enable the submit button.
        $('#submit').removeClass('disabled');
        $("#submit").removeAttr("disabled");
    }

    onUploadComplete(isSuccess, result) {
        if (isSuccess) {
            let fileUrls = [];
            //Set the uploaded URLs in the form
            myInstance.filesUploaded.forEach(function(f) {
                fileUrls.push(f.uri);
            });

            let payload = {
                FileUrls: fileUrls,
                LotCostCenterId: myInstance.lotCostCenterId,
                PurchaseDate: $('#purchase-date').val(),
                Phone: $('#phone').val()
            };

            $.ajax('/resaleownerverification/verify',
            {
                contentType: "application/json; charset=utf-8",
                dataType: 'json',
                data: JSON.stringify(payload),
                type: 'POST',
                xhrFields: {
                    // send through asp.net credential info so that backend can determine info about the currently authenticated user
                    withCredentials: true
                },
                beforeSend: function (request) {
                      // Add CSRF token to the header
                     let csrfToken = $("[name='__RequestVerificationToken']").val();
                     if (!csrfToken) {
                         throw "CSRF token is not set.";
                     }
                     request.setRequestHeader("__RequestVerificationToken", csrfToken);

                     //Prevent double submit
                     $('#submit').addClass('disabled');
                     $("#submit").attr("disabled", true);
                },
                success: function (response) {
                    if (response) {
                        if (response.IsSuccess) {
                            window.location.href = response.NextUrl;
                        }
                        else {
                            if (response.Message) {
                                $('#topError').addClass('is-visible').html("<p>"+ response.Message +"</p>");
                            }
                            window.location.href = response.NextUrl;
                        }
                    }

                    myInstance.reEnableSubmit();
                },
                error: function(response) {
                    $('#topError').addClass('is-visible').html("<p>An error occurred with submitting your resale owner verification form.  Please try again.</p>");
                    window.location.href = "#topError";

                    myInstance.reEnableSubmit();
                }
            });
            
        } else {
            $('#topError').addClass('is-visible').html("<p>" + result.errorMsg + "</p>");
            window.location.href = "#topError";

            myInstance.reEnableSubmit();
        }  
    }

    attachFileUploadValidatorEvents()
    {
        this.form.find('.upload-input').change(function(evtObj) 
        {
            let elem = $(evtObj.target);
            
            var fileGroup = elem.closest('.input-group');
            myInstance.updateRequiredFileMinLimitMessaging(fileGroup);

            if (elem.attr('data-invalid') != undefined)
            {       
                myInstance.updateValidationMessaging(elem);
            }
        });

        this.form.find('.file-uploader-remove').click(function(evt)
        {
            var inputElem = $(evt.currentTarget.parentElement.children[0]);
            inputElem.removeAttr("data-invalid");
            inputElem.removeAttr("invalid-file-size-too-small");
            inputElem.removeAttr("invalid-file-size-too-large");
            inputElem.removeAttr("invalid-content-type");
            inputElem.removeAttr("invalid-non-unique-filename");
            myInstance.updateValidationMessaging(inputElem);
        });

        this.form
            // form validation passed, form will submit if submit event not returned false
            .on("formvalid.zf.abide", function(ev,frm) {
                myInstance.lotCostCenterId = $('#lotCostCenterId').val();
                myInstance.startFileUpload();
            })
            // form validation failed
            .on("forminvalid.zf.abide", function(ev,frm) {
                let fileInputGroup = frm.find('.input-group.file-upload-container');
                if (fileInputGroup.attr('data-filegroup-min-required') != undefined) {
                    myInstance.updateRequiredFileMinLimitMessaging(fileInputGroup);
                }
            });
    }

    updateRequiredFileMinLimitMessaging(fileGroup)
    {
        let errMinFileRequiredId = 'err-min-file-required';
        
        $('#'+errMinFileRequiredId).remove();

        if (fileGroup.attr('invalid-filegroup-min-required') != undefined)
        {
            let msg = $('<span></span>')
                .text('At least one file is required.')
                .addClass('form-error is-visible')
                .attr('role', 'alert')
                .attr('id', errMinFileRequiredId);
            
            $('#fileUploadErrors').append( msg );
        }
    }

    updateValidationMessaging(elem)
    {   
        // Add/remove error messaging for filename not being unique
        let errNonUniqueId = 'err-non-unique-'+elem.attr('id');
        if (elem.attr("invalid-non-unique-filename") != undefined)
        {
            let msg = $('<span></span>')
                .text(elem.attr('aria-label') + ' file name is already used.')
                .addClass('form-error is-visible')
                .attr('role', 'alert')
                .attr('id', errNonUniqueId);
            
            $('#fileUploadErrors').append( msg );
        }
        else
        {
            $('#'+errNonUniqueId).remove();
        }

        // Add/remove error messaging for file being too small.
        let tooSmallErrId = 'err-too-small-'+elem.attr('id');
        if (elem.attr("invalid-file-size-too-small") != undefined)
        {
            let msg = $('<span></span>')
                .text(elem.attr('aria-label') + ' is too small.')
                .addClass('form-error is-visible')
                .attr('role', 'alert')
                .attr('id', tooSmallErrId);
            
            $('#fileUploadErrors').append( msg );
        }
        else
        {
            $('#'+tooSmallErrId).remove();
        }
        
        let tooLargeErrId = 'err-too-large-'+elem.attr('id');
        // Add/remove error messaging for file being too large.
        if (elem.attr("invalid-file-size-too-large") != undefined)
        {
            let msg = $('<span></span>')
                .text(elem.attr('aria-label') + ' is too large.')
                .addClass('form-error is-visible')
                .attr('id', tooLargeErrId)
                .attr('role', 'alert');
                
            $('#fileUploadErrors').append( msg );
        }
        else
        {
            $('#'+tooLargeErrId).remove();
        }

        let invalidFileTypeErrId = 'err-filetype-'+elem.attr('id');
        // Add/remove error messaging for file not being an acceptable file type.
        if (elem.attr("invalid-content-type") != undefined)
        {
            let msg = $('<span></span>')
                .text(elem.attr('aria-label') + ' is an invalid file type.')
                .addClass('form-error is-visible')
                .attr('id', invalidFileTypeErrId)
                .attr('role', 'alert');

            $('#fileUploadErrors').append( msg );
        }
        else
        {
            $('#'+invalidFileTypeErrId).remove();
        }
    }
}
